import React from "react";
import * as _ from "lodash";
import "../../css/page.css";
import {
  EarlyAccess,
  EarlyAccessTitle,
  EarlyAccessDescription,
  EarlyAccessProduct,
  EarlyAccessProductImage,
  EarlyAccessProductContainer,
  EarlyAccessProductGender,
  EarlyAccessProductName
} from "./styled_early_access_products";
import { Container, CenteredContent } from "../../styles/base";
import early_access_product_1 from "../../assets/img/early_access/product_1/product_1@3x.png";
import early_access_product_2 from "../../assets/img/early_access/product_2/product_2@3x.png";
import early_access_product_3 from "../../assets/img/early_access/product_3/product_3@3x.png";
import early_access_product_4 from "../../assets/img/early_access/product_4/product_4@3x.png";
import translations from "../../locales";
import getLocale from "../../helpers/getLocale";

export class EarlyAccessProducts extends React.Component {
  render() {
    const clickable = !!this.props.clickable;
    // console.debug("clickable", clickable);
    const locale = getLocale();
    const products = this.getEarlyAccessProducts(locale);
    const title = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.early_access.title"
    );
    const description = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.early_access.description"
    );

    return (
      <EarlyAccess>
        <EarlyAccessTitle>
          <div lang={locale}>{title}</div>
        </EarlyAccessTitle>
        <CenteredContent maxWidth="570px">
          <Container center>
            <div className="carousel-inner" role="listbox">
              <div className="item active text">
                <CenteredContent maxWidth="570px">
                  <EarlyAccessDescription block lang={locale}>
                    {description}
                  </EarlyAccessDescription>
                </CenteredContent>
              </div>
            </div>
          </Container>
        </CenteredContent>
        <EarlyAccessProductContainer>
          {products.map((product, index) => (
            <EarlyAccessProduct
              key={index}
              clickable={clickable}
              onClick={() => clickable && window.open(product.productUrl)}
            >
              <EarlyAccessProductImage src={product.image} />
              <EarlyAccessProductGender>
                {product.gender}
              </EarlyAccessProductGender>
              <EarlyAccessProductName>{product.name}</EarlyAccessProductName>
            </EarlyAccessProduct>
          ))}
        </EarlyAccessProductContainer>
      </EarlyAccess>
    );
  }

  getEarlyAccessProducts(locale) {
    return {
      en: [
        {
          image: early_access_product_1,
          gender: "Men",
          name: "I.T x Comme des Garçons",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_2,
          gender: "Men",
          name: "I.T x Off White",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_3,
          gender: "Women",
          name: "I.T x Opening Ceremony",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_4,
          gender: "Women",
          name: "I.T x MSGM",
          productUrl: "https://hk.iteshop.com/"
        }
      ],
      "zh-CN": [
        {
          image: early_access_product_2,
          gender: "[CN] Men",
          name: "[CN] I.T x Comme des Garçons",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_3,
          gender: "[CN] Men",
          name: "[CN] I.T x Off White",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_4,
          gender: "[CN] Women",
          name: "[CN] I.T x Opening Ceremony",
          productUrl: "https://hk.iteshop.com/"
        },
        {
          image: early_access_product_1,
          gender: "[CN] Women",
          name: "[CN] I.T x MSGM",
          productUrl: "https://hk.iteshop.com/"
        }
      ]
    }[locale];
  }
}



// WEBPACK FOOTER //
// ./src/components/early_access_products/early_access_products.js